module.exports = __webpack_public_path__ + "img/_italy.e8ebe6e0.png";